import axios from "axios";

export default class MissionAnalyzerService {
  public static async uploadMission(missionFile: File): Promise<string> {
    const formData = new FormData();
    formData.append("file", missionFile);
    const response = await axios.post("https://arma.npcs.games/missions/unpack", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    return response.data;
  }
}
